<template>
  <div v-if="total > 0" class="cont-guanzhu" v-loading="fullscreenLoading">
    <div class="user-much-num">共{{ total }}个关注的人</div>
    <div
      class="fans-item-one clearfix"
      v-for="(item, index) in tableData"
      :key="index"
    >
      <router-link
        target="_blank"
        :to="{ path: '/home', query: { userId: item.userInfo.userId } }"
        class="avatar-f"
      >
        <img
          class="ava"
          :src="
            `http://iss.21teacher.com/avatar/125/${item.userInfo.userId}/20.jpg`
          "
          alt=""
        />
      </router-link>
      <div
        class="img-list clearfix"
        v-for="(production, subIndex) in tableData[index].productionList"
        :key="subIndex"
      >
        <router-link
          :to="{ path: '/worksdetail', query: { id: production.id ,plate:production.belongSection} }"
          target="_blank"
          class="demo-img"
          ><img :src="production.productionCover" alt="" />
        </router-link>
      </div>
      <div class="user-infoes">
        <div class="user-name">
          <router-link
            target="_blank"
            :to="{ path: '/home', query: { userId: item.userInfo.userId } }"
            >{{ item.userInfo.userName }}
          </router-link>
        </div>
        <div class="shanchang">擅长领域：{{ item.userInfo.introduction }}</div>
        <div class="works-fans">
          作品 {{ item.userInfo.productionsCount }} | 文章
          {{ item.userInfo.archivesCount }} | 粉丝
          {{ item.userInfo.followersCount }}
        </div>
        <div class="qianming">个性签名：{{ item.userInfo.signature }}</div>
        <el-button
          v-if="item.followStatus == 2"
          @click="undoFollower(item, index)"
          >互相关注</el-button
        >
        <el-button
          v-if="item.followStatus == 1"
          @click="undoFollower(item, index)"
          >已关注</el-button
        >
        <el-button
          class="wgz-btn"
          v-if="item.followStatus == 0"
          @click="follower(item, index)"
          ><i class="el-icon-plus"></i> 关注</el-button
        >

        <el-button
          class="btn wgz-btn"
          v-if="item.friendStatus == 4"
          @click="addFriend(item.followingUserId, index)"
          ><i class="el-icon-plus"></i> 加好友</el-button
        >
        <!--<el-button
          class="btn"
          @click="toChart(item.followingUserId)"
          v-else-if="item.friendStatus == 2"
          >发消息</el-button
        >-->
        <el-button
          class="btn"
          v-else-if="item.friendStatus == 1"
          style="cursor:auto"
          >请求中</el-button
        >
      </div>
    </div>

    <div class="pagintion-f">
      <el-pagination
        background
        @current-change="getFollowingList"
        layout="prev, pager, next"
        :current-page="queryParam.pageIndex"
        :page-size="queryParam.pageSize"
        :hide-on-single-page="true"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
  <div v-else class="common-no-data">
    <img class="img" :src="require('@/assets/images/empty_img.png')" alt="" />
    <span class="words">抱歉！您访问的页面暂无数据</span>
  </div>
</template>

<script type="text/ecmascript-6">
import homeApi from '@/api/home'
import axios from 'axios';
import vue from 'vue';

vue.prototype.$axios = axios;


import { mapState } from "vuex";
import updateTdk from "@/utils/tdk";
export default {
    components: {},
    data() {
        return {
          headTitle: "title---rrdh",
          headKeywords: "keywords---rrdh",
          headDesc: "description---rrdh",
          isMounted: false, //for control not ssr render

          tableData: [],
            total: 0,
            fullscreenLoading: true,
            queryParam: {
                userId: 0,
                currentUserId: 0,
                pageIndex: 1,
                pageSize: 5
            },
            callbackurl:"",
        }
    },
  computed: {
    ...mapState(["userDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_USER_DETAIL", { detail: null });
  },
    mounted() {

      this.isMounted = true;

      let _this = this
      let id = _this.$route.query.userId
      if (id && parseInt(id) !== 0) {
        _this.queryParam.userId = id
      }
      if (_this.global.userModel != null) {
        _this.queryParam.currentUserId = _this.global.userModel.id
      }
      this.callbackurl="login?callback="+window.location.href;

      const alreadyIncremented = !!this.productionDetail;
      if (!alreadyIncremented) {
        this.fetchData().then(this.initData());
      } else {
        this.initData();
      }

    },
    methods: {
      fetchData(){
        return this.$store
                .dispatch("FETCH_USER_DETAIL", {
                  id: this.$route.query.userId
                })
                .finally(() => {
                  this.$loading(false);
                  this.setSeo()
                  updateTdk.call(this);
                });
      },
      initData(){
        this.getFollowingList(1);
      },
      setSeo(){
        this.headTitle = this.userDetail.userName+"的关注——人人动画网【官网】";
        this.headKeywords = this.userDetail.impressStr;
        this.headDesc =this.userDetail.userName+"的关注";
      },
        // setTitle(userId){
        //     let _this = this
        //     let head = document.getElementsByTagName('head');
        //     let meta = document.createElement('meta');
        //     let userUrl = "/rrbi/userInfo/userInfo/" + userId;
        //     _this.$axios.get(userUrl).then(function(result){
        //         if (result.data.code) {
        //             document.title =result.data.response.userName+"的关注——人人动画网【官网】"
        //             document.querySelector('meta[name="description"]').setAttribute('content', result.data.response.userName+"的关注")
        //         }
        //     })
        // },
        getFollowingList(page) {
            this.queryParam.pageIndex = page
            this.fullscreenLoading = true
            homeApi.followingList(this.queryParam).then(data => {
                // console.log(data)
                const re = data
                this.tableData = re.list
                this.total = re.total
                this.fullscreenLoading = false
            })
        },
        follower(item, index) {
            let _this = this;
            let url = '/api/checkLogin?time=' + new Date().getMilliseconds();
            this.$axios.get(url).then(function (result) {
                if (result.data.isLogin && result.data.casFastUserModel != null) {

                    homeApi.follower(item.followingUserId).then(data => {
                        // console.log(data)
                        const status = data.response.status
                        if (status != -1) {
                            _this.tableData[index].followStatus = status
                            _this.$message.success("关注成功")
                        } else {
                            _this.$message.error("关注失败")
                        }
                    })

                } else {
                    window.location.href="http://www.renrendonghua.com/"+_this.callbackurl;

                }
            })

        },
        undoFollower(item, index) {
            let _this = this;
            let url = '/api/checkLogin?time=' + new Date().getMilliseconds();
            this.$axios.get(url).then(function (result) {
                if (result.data.isLogin && result.data.casFastUserModel != null) {

                    homeApi.undoFollower(item.followingUserId).then(data => {
                        // console.log(data)
                        const status = data.response.status
                        if (status == 1) {
                            _this.tableData[index].followStatus = 0
                            _this.$message.success("取消成功")
                        } else {
                            _this.$message.error("取消失败")
                        }
                    })

                } else {
                    window.location.href="http://www.renrendonghua.com/"+_this.callbackurl;

                }
            })

        },
        addFriend(friendId, index) {
            let _this = this;
            if (_this.global.isLogin) {
                let url = '/rrbi/friends/add/' + friendId + "?ti=" + new Date().getMilliseconds();
                _this.$axios.get(url).then(function (result) {
                    console.log(result)
                    if (result.data.response.code == 1) {
                        _this.$message.success(result.data.response.msg)
                        _this.tableData[index].friendStatus = 1
                    } else {
                        _this.$message.error(result.data.response.msg)
                    }
                })
            }
        }
    }
}
</script>

<style scoped lang="less">
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}

//@import "../../../assets/less/stylePublic.less";
</style>
